import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { dialog: String, frame: String, focus: String }

  open() {
    window.plazaOpenModal(this.dialogValue, this.frameValue, this.focusValue)
  }
}
